export default __webpack_public_path__ + "static/MediaContentThree-5b72ad07a0522c6ea109943bdced43c3.webp";